export default {
    data() {
        return {
            perPage: 20,
            count: 0,
            page: 1,
        }
    }
}
